<form class="sdp-saml-wizard-form" novalidate>
	<div class="sdp-clear"></div>
	<div>
		<div class="sdp-form-control">
			<div class="file-upload sdp-image-manager-container">
				<input #fileInput type="file" (change)="fileOnChange($event)" class="sdp-image-manager-input" />
				<button id="imageManagerButton" type="button" color="accent" mat-raised-button class="sdp-image-manager-button sdp-image-manager-overlay">{{ "imageManager.selector.button" | translate }}</button>
				<button type="button" color="accent" mat-raised-button class="sdp-image-manager-button sdp-image-button-default" (click)="useDefaultImage()">{{ "imageManager.selector.button.default" | translate }}</button>
			</div>
		</div>
		<div>
			<div>
				<h3>Preview</h3>
			</div>
			<div>
				<div class="sdp-image-cropper-preview">
					<sdp-application-image [applicationImage]="imageSelect" size="full"></sdp-application-image>
				</div>
			</div>
			<div class="sdp-image-cropper-info">
				<div>{{ "imageManager.file.info" | translate }}</div>
			</div>
		</div>
	</div>
</form>